/**
 * Fleet Mode — shared types (Phase 1).
 *
 * The driver-side mode discriminator (`Mode`) lives on `User.current_mode`
 * + `Session.mode_used`; the charger-side derived classification
 * (`ChargerAccessMode`) is computed from `Charger.fleet_id` +
 * `Charger.allow_mixed_use` + the parent Fleet's
 * `allows_mixed_use_default` by `deriveChargerAccessMode`
 * (see `../lib/chargerAccessMode.ts`).
 *
 * Phase 1 ships these types + the derive helper; no read or write path
 * consumes them yet. Phase 2 wires the API gate.
 */
import { z } from 'zod';
export const ModeSchema = z.enum(['fleet', 'public']);
export const ChargerAccessModeSchema = z.enum(['public', 'fleet_only', 'mixed']);
//# sourceMappingURL=fleet-mode.js.map